import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

function SiteLogo({ size = 'normal' }) {
  const isLarge = size === 'large';

  return (
    <Box
      component={Link}
      to="/"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        textDecoration: 'none',
        color: 'inherit',
      }}
    >
      <Box
        component="img"
        src={process.env.PUBLIC_URL + '/mirror.png'}
        alt=""
        sx={{ width: isLarge ? 40 : 26, height: isLarge ? 40 : 26 }}
      />
      <Typography
        variant={isLarge ? 'h5' : 'subtitle1'}
        noWrap
        sx={{
          fontFamily: 'monospace',
          fontWeight: 700,
          letterSpacing: '.15rem',
        }}
      >
        POE Regex KR
      </Typography>
    </Box>
  );
}

export default SiteLogo;
